import { render, staticRenderFns } from "./DepositTransactionList.vue?vue&type=template&id=6d7913be&"
import script from "./DepositTransactionList.vue?vue&type=script&lang=js&"
export * from "./DepositTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports